import { i18nMark } from 'lingui-react';

import buildEnum from 'utils/buildEnum';

export const mismatchTypes = buildEnum(['assetMismatch', 'customerMismatch']);

export const labelForType = {
  [mismatchTypes.assetMismatch]: i18nMark('Unit Number:'),
  [mismatchTypes.customerMismatch]: i18nMark('Fleet:'),
};



// WEBPACK FOOTER //
// ./src/compositions/CaseMismatchsBar/constants.js